import { spiffCoreConfiguration } from "../Configuration";
import { ResourceGenerationError } from "../util/exception";
import { fetch } from "../util/crossplatform";

export const shortenUrl = async (longUrl: string): Promise<string> => {
    const shortenerUrl = `${spiffCoreConfiguration.getServicesApiUrl()}/shortener`;
    try {
        const response = await fetch(shortenerUrl, {
            method: "POST",
            body: JSON.stringify({ longUrl }),
            headers: {
                "Content-Type": "application/json",
            },
        });
        const json = await response.json();
        return json.shortUrl;
    } catch (e) {
        console.error(e);
        throw new ResourceGenerationError("Failed to shorten URL, see console.");
    }
};
